<template>
  <div :class="`statistics-key d-f ai-c ${color} ${borderless ? 'borderless' : ''} ${active ? 'active' : ''}`">
    <i :class="`icon-${icon}`" />
    <div>
      <h2>
        {{ displayTotal }}{{ afterLabel }}
        <template v-if="showPercent">
          <span>({{ percent }}%)</span>
        </template>
      </h2>
      <p>
        {{ label }}
      </p>
    </div>
  </div>
</template>

<script>

const NUMBER_SPEED = 200;

export default {
  props: {
    borderless: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    icon: {
      type: String,
    },
    total: {
      type: Number,
      default: 0,
    },
    percent: {
      // eslint-disable-next-line
      type: Number|String,
    },
    showPercent: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    afterLabel: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  methods: {
    animateNumberUp(from, to) {
      const value = this[from];
      const data = this[to];
      const time = value / NUMBER_SPEED;

      if (data < value) {
        this[to] = Math.ceil(data + time);
        setTimeout(this.animateNumberUp.bind(null, from, to), 1);
      } else {
        this[to] = this[from];
      }
    },
    animateNumberDown(from, to) {
      const value = this[from];
      const data = this[to];
      const time = data / NUMBER_SPEED;

      if (data > value) {
        this[to] = Math.ceil(data - time);
        setTimeout(this.animateNumberDown.bind(null, from, to), 1);
      } else {
        this[to] = this[from];
      }
    },
    startAnimation() {
      if (this.total > this.displayTotal) {
        this.animateNumberUp('total', 'displayTotal');
      } else {
        this.animateNumberDown('total', 'displayTotal');
      }
    },
  },
  data() {
    return {
      displayTotal: 0,
    };
  },
  watch: {
    total() {
      setTimeout(() => {
        this.startAnimation();
      }, 500);
    },
  },
  mounted() {
    setTimeout(() => {
      this.startAnimation();
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
i {
  font-size: 24px;
  margin-right: 12px;
}

h2 {
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;

  span {
    font-size: 16px;
  }
}

p {
  color: #A4A7B0;
  font-size: 12px;
}

@media (min-width: 1024px) {
  i {
    font-size: 48px;
  }

  h2 {
    font-size: 24px;
    line-height: 32px;

    span {
      font-size: 18px;
    }
  }

  p {
    font-size: 14px;
  }
}

.statistics-key {
  border: 2px solid #eaeaea;
  border-radius: 6px;
  margin: 3px;
  padding: 6px 2px 6px 10px;
  transition: border-color .3s;
  width: calc(50% - 6px);

  &.borderless {
    border: 2px solid transparent;
  }

  &:hover:not(.borderless) {
    cursor: pointer;
  }

  &:hover:not(.active):not(.borderless) {
    border-color: #b9b9b9;
  }

  &.blue {
    i {
      color: var(--graph-blue);
    }
    &.active {
      border-color: var(--graph-blue);
    }
  }
  &.ocean {
    i {
      color: var(--graph-ocean);
    }
    &.active {
      border-color: var(--graph-ocean);
    }
  }
  &.green {
    i {
      color: var(--graph-green);
    }
    &.active {
      border-color: var(--graph-green);
    }
  }
  &.peach {
    i {
      color: var(--graph-peach);
    }
    &.active {
      border-color: var(--graph-peach);
    }
  }
  &.purple {
    i {
      color: var(--graph-purple);
    }
    &.active {
      border-color: var(--graph-purple);
    }
  }
  &.orange {
    i {
      color: var(--graph-orange);
    }
    &.active {
      border-color: var(--graph-orange);
    }
  }
  &.grey {
    i {
      color: var(--graph-grey);
    }
    &.active {
      border-color: var(--graph-grey);
    }
  }
  &.pink {
    i {
      color: var(--graph-pink);
    }
    &.active {
      border-color: var(--graph-pink);
    }
  }

  @media (min-width: 1024px) {
    margin: 6px;
    padding: 12px 4px 12px 20px;
    width: calc(25% - 12px);
  }
}
</style>
